export type DogBreedId =
  | 'maltese'
  | 'corgi'
  | 'poodle'
  | 'husky'
  | 'dachshund'
  | 'golden';

export type BodyArchetype = 'arch_small_fluffy' | 'arch_long_low' | 'arch_medium';

export type DogDef = {
  id: DogBreedId;
  namePl: string;
  defaultName: string;
  archetype: BodyArchetype;
  defaultColor: string;
  personalityPl: string;
};

export const DOGS: Record<DogBreedId, DogDef> = {
  maltese: {
    id: 'maltese',
    namePl: 'Maltańczyk',
    defaultName: 'Misia',
    archetype: 'arch_small_fluffy',
    defaultColor: '#FFF5EE',
    personalityPl: 'Delikatna i przytulaśna',
  },
  corgi: {
    id: 'corgi',
    namePl: 'Corgi',
    defaultName: 'Lola',
    archetype: 'arch_long_low',
    defaultColor: '#F4A460',
    personalityPl: 'Wesoła i energiczna',
  },
  poodle: {
    id: 'poodle',
    namePl: 'Pudel',
    defaultName: 'Pusia',
    archetype: 'arch_small_fluffy',
    defaultColor: '#E6E0F8',
    personalityPl: 'Elegancka i ciekawska',
  },
  husky: {
    id: 'husky',
    namePl: 'Husky',
    defaultName: 'Luna',
    archetype: 'arch_medium',
    defaultColor: '#B0C4DE',
    personalityPl: 'Odważna i lojalna',
  },
  dachshund: {
    id: 'dachshund',
    namePl: 'Jamnik',
    defaultName: 'Figa',
    archetype: 'arch_long_low',
    defaultColor: '#8B4513',
    personalityPl: 'Zabawna i uparta',
  },
  golden: {
    id: 'golden',
    namePl: 'Golden retriever',
    defaultName: 'Bella',
    archetype: 'arch_medium',
    defaultColor: '#FFD700',
    personalityPl: 'Przyjazna i ciepła',
  },
};

export const DOG_BREED_IDS = Object.keys(DOGS) as DogBreedId[];

export const DOG_COLORS = [
  '#FFB6C1', // pink
  '#B8E6D0', // mint
  '#FFDAB9', // peach
  '#E6E0F8', // lavender
  '#BDE0FE', // baby blue
  '#FFF3E9', // cream
  '#F4A460', // sandy
  '#FFD700', // gold
] as const;
